import { PROVEEDOR } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null, 
    ventana_filtros: false, 
    filtros: null,
    productos: {
        listado: [],
        detalles: null
    }
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case PROVEEDOR.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case PROVEEDOR.AGREGAR:
            let proveedor_agregar = state.listado;

            proveedor_agregar = [
                ...proveedor_agregar, payload
            ];

            return {
                ...state, 
                listado: proveedor_agregar
            };

        case PROVEEDOR.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        case PROVEEDOR.EDITAR:
            let proveedor_editar = state.listado;

            proveedor_editar = proveedor_editar.map(proveedor => proveedor._id === payload._id ? payload : proveedor);

            return {
                ...state, 
                listado: proveedor_editar
            };

        case PROVEEDOR.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter( proveedor => proveedor._id !== payload.id )
            };

        case PROVEEDOR.FILTROS:
            return {
                ...state,
                ventana_filtros: payload
            };
        
        case PROVEEDOR.PRODUCTOS_BUSCAR:
            return {
                ...state,
                productos: {
                    ...state.productos,
                    listado: payload
                }
            };
        case PROVEEDOR.PRODUCTOS_DETALLES:
            return {
                ...state,
                productos: {
                    ...state.productos,
                    detalles: payload,
                },
            };

        case PROVEEDOR.PRODUCTOS_EDITAR: {
            const productosEditados = state.productos.listado.map(prod =>
                String(prod._id) === String(payload._id) ? payload : prod
            );

            return {
                ...state,
                productos: {
                    ...state.productos,
                    listado: productosEditados,
                },
            };
        }
        case PROVEEDOR.PRODUCTOS_ELIMINAR :
            return {
                ...state,
                productos: {
                    ...state.productos,
                    listado: state.productos.listado.filter(
                        (producto) => String(producto._id) !== String(payload)
                    )
                }
            };

        default:
            return state;
    }
}